import styled from 'styled-components';

export const Content = styled.span.withConfig({ componentId: 'sc-10sgiot-0' })`
  text-align: left;
  li {
    text-align: left;
  }
`;
